export default {
  progress: {
    position: 'absolute',
    top: 'calc(50% - 9px);',
    right: 9,
  },
};
